/**
 * Markdown-it plugin for inline extras: hidden metadata fields, hashtags,
 * and @-mentions — matching the markdown-editor wiki-syntax extension.
 *
 *   [key:: value] → <span class="cm-field-hidden"></span>   (entirely hidden)
 *   #tag          → <span class="cm-hashtag-preview">#tag</span>
 *   @user/path    → <span class="cm-reference-preview">@user/path</span>
 */

const FIELD_RE = /\[([^\]]+?)::\s*([^\]]*?)\]/; // [key:: value]
const HASHTAG_RE = /^#([\w][\w-]*)/;
const MENTION_RE = /^@([\w][\w/-]*(?:\.[\w/-]+)*)/;

export default function inlineExtrasPlugin(md) {
  const pushHtml = (state, html) => {
    const token = state.push('html_inline', '', 0);
    token.content = html;
    return token;
  };
  const esc = (s) => md.utils.escapeHtml(s == null ? '' : String(s));

  // --- hidden metadata fields [key:: value] — must run before link parsing ---
  md.inline.ruler.before('link', 'metadata_field', (state, silent) => {
    const pos = state.pos;
    if (state.src[pos] !== '[') return false;
    const m = FIELD_RE.exec(state.src.slice(pos));
    if (!m || m.index !== 0) return false;
    if (silent) return true;
    pushHtml(state, `<span class="cm-field-hidden"></span>`);
    state.pos += m[0].length;
    return true;
  });

  // --- hashtags #tag (never inside ATX headings or after a word char) -------
  md.inline.ruler.after('text', 'hashtag', (state, silent) => {
    const pos = state.pos;
    if (state.src[pos] !== '#') return false;
    if (pos > 0 && /\w/.test(state.src[pos - 1])) return false;
    const m = HASHTAG_RE.exec(state.src.slice(pos));
    if (!m) return false;
    if (silent) return true;
    pushHtml(state, `<span class="cm-hashtag-preview">#${esc(m[1])}</span>`);
    state.pos += m[0].length;
    return true;
  });

  // --- @mentions @user/path --------------------------------------------------
  md.inline.ruler.after('text', 'mention', (state, silent) => {
    const pos = state.pos;
    if (state.src[pos] !== '@') return false;
    if (pos > 0 && /\w/.test(state.src[pos - 1])) return false;
    const m = MENTION_RE.exec(state.src.slice(pos));
    if (!m) return false;
    if (silent) return true;
    pushHtml(state, `<span class="cm-reference-preview">@${esc(m[1])}</span>`);
    state.pos += m[0].length;
    return true;
  });
}
